
import { createAction, props } from '@ngrx/store';


// COM Hora actualización *******
export const addHoraActualizado = createAction(
  '[ADD HOUR NMJ] ',
  props<{ newHora: string }>()
);

export const removeHoraActualizado = createAction(
  '[REMOVE HOUR NMJ]',
);

// COM Contador de apertura Movil filtro *******
export const addContador = createAction(
  '[ADD COUNTER] ',
  props<{ newCounter: number }>()
);

export const removeContador = createAction(
  '[REMOVE COUNTER]',
);












